import { getDiscountAmount, getSellerName, priceToNumber } from '@/lib/utils';
import { AFFILIATION_NAME_OPERATOR, getProductCategoriesTree } from './helpers';

import type { TypeGTMProduct } from '@/types';

export const normalizeEventItem = (
  product: any,
  index: number | undefined,
  qty: number,
  variation: any = null,
) => {
  let regularPrice = product.regularPrice;
  let salePrice = product.salePrice;
  if (variation) {
    regularPrice = variation.node.regularPrice;
    salePrice = variation.node.salePrice;
  }

  let discount;
  if (product.onSale) {
    discount = Number.parseFloat(
      getDiscountAmount(
        priceToNumber(regularPrice),
        priceToNumber(salePrice),
      ).toFixed(2),
    );
  }

  const price = !variation
    ? priceToNumber(product.regularPrice)
    : priceToNumber(variation.node.regularPrice);

  let item: TypeGTMProduct = {
    item_id: product.sku,
    item_name: product.name,
    // TODO: cuando se implmente el buy box esto no servirá porque puede haber varios sellers
    affiliation: variation
      ? getSellerName(variation.attributes)
      : AFFILIATION_NAME_OPERATOR,
    coupon: null,
    currency: 'EUR',
    discount: discount ? discount * qty : null,
    index: index ?? null,
    item_brand: product.brand,
    item_list_name: null,
    item_list_id: null,
    item_variant: variation ? variation.node.sku : null,
    price: price * qty,
    quantity: qty,
  };

  if (product.productCategories) {
    const categories = getProductCategoriesTree(product);

    item = {
      ...item,
      ...categories,
    };
  }

  return item;
};
